/* eslint-disable ts/no-unsafe-assignment */
import { createRouter, createWebHistory } from "vue-router";

import DashboardHomeView from "@/views/dashboard/home/DashboardHomeView.vue";
import DiscountVouchersViews from "@/views/dashboard/home/DiscountVouchersView.vue";
import GiftsView from "@/views/dashboard/home/GiftsView.vue";
import ReceiptsView from "@/views/dashboard/home/ReceiptsView.vue";
import HowItWorksView from "@/views/dashboard/HowItWorksView.vue";
import ReceiptView from "@/views/dashboard/ReceiptView.vue";
import TakeReceiptPhotoView from "@/views/dashboard/TakeReceiptPhotoView.vue";
import LoginView from "@/views/LoginView.vue";

export const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),

  scrollBehavior(to, from) {
    if (to.hash) {
      return { el: to.hash };
    }

    // When accessing the home page from the login page, we want to scroll to the top of the page.
    // Otherwise, we want to scroll to the top of the navigation menu when already on the home page.
    if (to.path.includes("/accueil/") && from.name && from.name !== "login") {
      return { el: "#navigation-menu" };
    }

    return { top: 0 };
  },

  routes: [
    {
      path: "/",
      component: LoginView,
    },
    {
      path: "/connexion",
      name: "login",
      component: LoginView,
    },
    {
      path: "/tableau-de-bord",
      name: "app",
      children: [
        {
          path: "accueil",
          name: "home",
          component: DashboardHomeView,
          children: [
            {
              path: "cadeaux",
              name: "gifts",
              component: GiftsView,
            },
            {
              path: "bons-de-reduction",
              name: "vouchers",
              component: DiscountVouchersViews,
            },
            {
              path: "tickets",
              name: "receipts",
              component: ReceiptsView,
            },
          ],
        },
        {
          path: "tickets/:id",
          name: "receipt",
          component: ReceiptView,
        },
        {
          path: "photographier-mon-ticket",
          name: "take-picture-of-ticket",
          component: TakeReceiptPhotoView,
        },
        {
          path: "fonctionnement-du-programme",
          name: "how-it-works",
          component: HowItWorksView,
        },
      ],
    },
  ],
});
